import {
  type FlowReferenceTableCreateBody,
  type FlowReferenceTableListQueryInput,
  type FlowReferenceTableUpdateBody,
} from 'flow-schema';

import { type Common } from '../common.js';
import { type ReferenceTable } from '../models/flow/referenceTable.js';

export class API {
  common: Common;
  baseEndpoint = '/flow/reference-tables';

  constructor(common: Common) {
    this.common = common;
  }

  async findAll(queryParams?: FlowReferenceTableListQueryInput): Promise<ReferenceTable[]> {
    const url = this.common.constructPath(this.baseEndpoint, queryParams);
    return await this.common.getJSON(url);
  }

  async findOneById(id: string): Promise<ReferenceTable> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    return await this.common.getJSON(url);
  }

  async getColumnNames(id: string): Promise<string[]> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}/column-names`);
    return await this.common.getJSON(url);
  }

  async create(values: FlowReferenceTableCreateBody): Promise<ReferenceTable> {
    const url = this.common.constructPath(`${this.baseEndpoint}`);
    return await this.common.postJSON(url, values);
  }

  async update(
    referenceTableId: string,
    values: FlowReferenceTableUpdateBody
  ): Promise<ReferenceTable> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${referenceTableId}`);
    return await this.common.patchJSON(url, values);
  }

  async delete(referenceTableId: string): Promise<void> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${referenceTableId}`);
    return await this.common.deleteJSON(url);
  }
}
